import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><g stroke="currentColor" fill="none"><path d="M.5 7.5h23v16H.5zM4 7.5a1.1 1 0 0116 0" /></g></svg>;